export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_MODAL_DATA = 'SET_MODAL_DATA';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
